import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import type { WorkspaceMode } from '@auw/workspace-utils';
import {
  extractIdFromPath,
  getRouteByPath,
  modeToPath,
  modeToPathWithId,
  type RouteEntry,
} from '@auw/workspace-utils';

export interface WorkspaceRouteState {
  pathname: string;
  entry: RouteEntry | null;
  mode: WorkspaceMode | null;
  itemId: string | null;
  basePath: string | null;
  hasIdParam: boolean;
}

export function resolveWorkspaceRoute(pathname: string): WorkspaceRouteState {
  const entry = getRouteByPath(pathname) ?? null;
  const mode = entry?.mode ?? null;
  const itemId = entry ? (extractIdFromPath(pathname) ?? null) : null;
  return {
    pathname,
    entry,
    mode,
    itemId,
    basePath: entry?.path ?? null,
    hasIdParam: entry?.hasIdParam ?? false,
  };
}

export function useWorkspaceRoute(): WorkspaceRouteState {
  const { pathname } = useLocation();
  return useMemo(() => resolveWorkspaceRoute(pathname), [pathname]);
}

export function useWorkspaceRouteMode(): WorkspaceMode | null {
  return useWorkspaceRoute().mode;
}

export function buildWorkspaceModePath(mode: WorkspaceMode): string {
  return modeToPath(mode);
}

export function buildWorkspaceItemPath(mode: WorkspaceMode, itemId: string): string {
  return modeToPathWithId(mode, itemId);
}

export function normalizeComposerWorkspaceMode(
  mode: WorkspaceMode | null | undefined,
): WorkspaceMode {
  if (mode === 'widget' || mode === 'feed' || mode === 'tools') {
    return 'agent';
  }
  return mode ?? 'agent';
}
